<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import CommonRules from "@/mixins/CommonRules";
import UserAuth from "@/mixins/UserAuth";
import UsersModalCommon from "@/components/Users/UsersModalCommon.vue";
import History from "@/components/commonComponents/History.vue";

export default {
    name: "UsersModal",
    components: {
        History,
        UsersModalCommon,
        VFormModified,
        AjaxLoad,
    },
    mixins: [
        CommonRules,
        UserAuth,
    ],
    data() {
        return {
            isShow: false,
            isResolved: false,
            isValid: false,
            isSubmit: false,
            wasModified: false,
            result: false,
            idUsers: null,
            loadPromise: null,
            original: {},
            data: {},
            notifyOptions: {
                title: 'Пользователь',
            },
            tab: 'common',
        };
    },
    computed: {
        isDisabled() {
            return this.isNew ?
                !this.user?.permissions?.byModule?.users?.canCreate :
                !(this.user?.permissions?.byModule?.users?.canUpdate && this.data?.permissions?.canUpdate);
        },
        isCanSubmit() {
            return !this.isDisabled && this.isValid && this.wasModified && !this.isSubmit && this.isResolved;
        },
        isNew() {
            return !this.idUsers;
        },
        isLoading() {
            return !this.isResolved || this.isSubmit;
        },
        loadUrl() {
            return this.$apiUrl.getUserUrl({
                id_users: this.idUsers,
            });
        },
        saveUrl() {
            return this.isNew ?
                this.$apiUrl.getUsersUrl() :
                this.loadUrl;
        },
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
        tab() {
            // При смене вкладки возвращаем фокус диалогу
            this.$nextTick(() => {
                this.$refs.dialogContent?.focus();
                this.$refs.dialogContent?.$el?.focus();
            });
        },
    },
    methods: {
        show(idUsers) {
            this.idUsers = idUsers;
            this.loadPromise = this.isNew ? Promise.resolve({data: {data: {is_active: 1}}}) : this.$api.get(this.loadUrl);
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onClickSave() {
            this.isSubmit = true;
            const method = this.isNew ? 'post' : 'put';
            this.$api[method](this.saveUrl, this.data)
                .then((response) => {
                    this.result = response;
                    this.notifySuccess('Успешно сохранен');
                    this.close();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.isShow = false;
        },
        isDisabledField(field) {
            return this.isNew ?
                !this.user?.permissions?.byModule?.users?.canCreate :
                !(this.user?.permissions?.byModule?.users?.canUpdate && this.data?.permissions?.isEditableField[field]);
        },
        onWrapperKeydown(e) {
            if (e.key === 'Escape' && !this.wasModified) {
                this.close();
            }
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        :persistent="wasModified"
        :max-width="tab === 'history' ? 1200 : 500"
        scrollable
    >
        <ajax-load
            v-model="original"
            :promise="loadPromise"
            :transform="response => response.data.data"
            :resolved.sync="isResolved"
        >
            <v-form-modified
                v-model="isValid"
                :original="original"
                :modified.sync="data"
                :was-modified.sync="wasModified"
                :disabled="isLoading"
                @submit.prevent="onClickSave"
            >
                <v-card :loading="isLoading">
                    <v-card-title>{{ isNew ? 'Новый пользователь' : (original.name || original.email) }}</v-card-title>
                    <div ref="dialogContent" tabindex="0" @keydown="onWrapperKeydown">
                        <v-tabs v-model="tab">
                            <v-tab tab-value="common">Общее</v-tab>
                            <v-tab v-if="!isNew" tab-value="history">История</v-tab>
                        </v-tabs>
                    </div>
                    <v-card-text>
                        <v-tabs-items v-model="tab">
                            <v-tab-item value="common">
                                <users-modal-common
                                    :data="data"
                                    :is-disabled-field="isDisabledField"
                                    :is-new="isNew"
                                ></users-modal-common>
                            </v-tab-item>
                            <v-tab-item value="history">
                                <history
                                    :url="$apiUrl.getUserHistoryUrl({id_users: idUsers})"
                                    :table-props="{groupBy:null}"
                                ></history>
                            </v-tab-item>
                        </v-tabs-items>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onClickCancel">
                            Отмена
                        </v-btn>
                        <v-btn
                            :disabled="!isCanSubmit"
                            color="primary"
                            type="submit"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form-modified>
        </ajax-load>
    </v-dialog>
</template>

<style scoped lang="scss">
.v-tabs {
    border-bottom: 1px solid #c0c0c044;
}
</style>
